class RogaineDetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.modalContent = this.querySelector('.search-modal__content');
    this.focusableElements = [];
    this.previousFocusElement = null;

    const searchLink = this.querySelector('.details-modal__search-link');
    if (searchLink) {
      searchLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open();
      });

      searchLink.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.open();
        }
      });
    }

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    const closeButton = this.querySelector('.search-modal__close-button');
    if (closeButton) {
      closeButton.setAttribute('tabindex', '0');

      closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.close();
      });

      closeButton.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.stopPropagation();
          this.close();
        }
      });
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  captureFocusableElements() {
    this.focusableElements = Array.from(
      this.modalContent.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
    );
  }

  isOpen() {
    return this.detailsContainer && this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    if (this.detailsContainer.hasAttribute('open')) {
      this.close();
    } else {
      this.open();
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
      this.close(false);
    }
  }

  open() {
    if (this.detailsContainer && this.modalContent) {
      this.previousFocusElement = document.activeElement;

      this.detailsContainer.setAttribute('open', true);
      this.captureFocusableElements();

      const firstFocusableElement = this.focusableElements[0];
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }

      this.modalContent.addEventListener('keydown', this.trapFocus.bind(this));

      document.body.classList.add('overflow-hidden');
    }
  }

  close(focusToggle = true) {
    if (this.detailsContainer) {
      this.detailsContainer.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');

      if (this.previousFocusElement) {
        this.previousFocusElement.focus();
      }

      this.modalContent.removeEventListener('keydown', this.trapFocus.bind(this));

      this.preventOpen = true;

      setTimeout(() => {
        this.preventOpen = false;
      }, 50);
    }
  }

  trapFocus(event) {
    const lastFocusableElement = this.focusableElements[this.focusableElements.length - 1];
    const firstFocusableElement = this.focusableElements[0];

    if (event.key === 'Tab') {
      if (event.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus();
          event.preventDefault();
        }
      } else {
        if (document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus();
          event.preventDefault();
        }
      }
    }
  }
}

customElements.define('rogaine-details-modal', RogaineDetailsModal);
